module.exports = __webpack_public_path__ + "static/media/Logo.6282fd42.svg";